import React, { Component } from "react";
import { Link } from "react-router-dom";
import firebase from "../../firebase";
import {
	Grid,
	Form,
	Segment,
	Button,
	Header,
	Message,
	Icon
} from "semantic-ui-react";

export default class Login extends Component {
	state = {
		email: "",
		username: "",
		password: "",
		passwordConfirmation: "",
		errors: [],
		loading: false,
		usersRef: firebase.database().ref("users")
	};

	displayErrors = errors =>
		errors.map((error, i) => <p key={i}>{error.message}</p>);

	handleInputError = (errors, inputName) => {
		return errors.some(error => error.message.toLowerCase().includes(inputName))
			? "error"
			: "";
	};

	handleChange = e => {
		this.setState({ [e.target.name]: e.target.value });
    };
    
    isFormValid = ({email,password}) =>{ 
        return(email && password)}

	handleSubmit = e => {
		e.preventDefault();
		if (this.isFormValid(this.state)) {
			this.setState({
				errors: [],
				loading: true
            });
            firebase
            .auth()
            .signInWithEmailAndPassword(this.state.email,this.state.password)
            .then(signedInUser => {
                console.log(signedInUser)
                this.setState({
                    loading:false
                })
            })
            .catch( e =>{
                console.log(e)
                this.setState({
                    errors : this.state.errors.concat(e),
                    loading:false
                })
            })
		}
	};

	render() {
		const {
			email,
			password,
			errors,
			loading
		} = this.state;
		return (
			<Grid textAlign="center" verticalAlign="middle" className="app">
				<Grid.Column style={{ maxWidth: 450 }}>
					<Header as="h2" icon color="violet" textAlign="center">
						<Icon name="code branch" color="violet" />
						Login to DevChat
					</Header>
					<Form size="large" onSubmit={this.handleSubmit}>
						<Segment stacked>
							<Form.Input
								fluid
								name="email"
								icon="mail"
								iconPosition="left"
								placeholder="Email Address"
								onChange={this.handleChange}
								type="email"
								className={this.handleInputError(errors, "email")}
								value={email}
							/>
							<Form.Input
								fluid
								name="password"
								icon="lock"
								iconPosition="left"
								placeholder="Password"
								onChange={this.handleChange}
								className={this.handleInputError(errors, "password")}
								type="password"
								value={password}
							/>

							<Button
								disabled={loading}
								className={loading ? "loading" : ""}
								color="violet"
								fluid
								size="large"
							>
								Submit
							</Button>
						</Segment>
					</Form>
					{errors.length > 0 && (
						<Message error>
							<h1>Error</h1>
							{this.displayErrors(errors)}
						</Message>
					)}
					<Message>
						Don't have an account? <Link to="/signup">register</Link>
					</Message>
				</Grid.Column>
			</Grid>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Auth/Login.js